/* eslint-disable */
import FirstPaymentDefinitionServiceClass from './firstPaymentDefinitionClass';

let firstPaymentDefinitionService;

// eslint-disable-next-line prefer-const
firstPaymentDefinitionService = firstPaymentDefinitionService || new FirstPaymentDefinitionServiceClass();

export default firstPaymentDefinitionService;
